import {AfterViewChecked, AfterViewInit, Component, ElementRef, OnInit, ViewChild, DestroyRef} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import { StorageService } from '../../../../Services/storage.service';
import {DataService} from '../../../../Services/data.service';
import { AppConfigService } from '../../../../Services/app-config.service';
import { Title } from '@angular/platform-browser';
import { DateFilterService } from '../../../../Services/dateFilter.service';
import { FilterPipe } from 'ngx-filter-pipe';
import { NotificationService } from '../../../../Services/notification.service';
import { ActivatedRoute, Router } from '@angular/router';
import { EmailService } from '../../../../Services/email.service';
import { DataExportService } from '../../../../Services/dataExport.service';
import { ResponseModel } from '../../../../DataModels/response-model';
import { EmailPassDataServiceService } from '../../../../Services/email-pass-data-service.service';
import { CashFlowModel } from '../../../../DataModels/cash-flow-model';
import { CashFlowDetailModel } from '../../../../DataModels/cash-flow-detail-model';
import { DecimalPipe } from '@angular/common';
import {EmailModel} from '../../../../DataModels/email-model';
import {Modal} from 'bootstrap';
import {SendEmailModalComponent} from '../../../common/send-email-modal/send-email-modal.component';
import {ReportPrintService} from '../../../../Services/report-print.service';

@Component({
  selector: 'app-cash-flow',
  templateUrl: './cash-flow.component.html',
  styleUrls: ['./cash-flow.component.css'],
  standalone: false
})
export class CashFlowComponent implements OnInit, AfterViewInit, AfterViewChecked {
  @ViewChild('ExcelExport', { static: false }) ExcelExport: ElementRef;

  // Email modal integration
  reportDataToSendInEmail: EmailModel = new EmailModel();
  // Standard report header button configuration
  buttonConfig: any = {
    reportFormat: false,
    printReport: true,
    email: true,
    update: true,
    exportExcel: true,
    close: true,
  };
  @ViewChild(SendEmailModalComponent, {read: ElementRef}) private localSendEmailModalHost: ElementRef;

  private rptName: string;
  lapCount = 0;
  cashFlowData: CashFlowModel[];
  tempCashFlowData: CashFlowModel[];
  finalCashFlowData: CashFlowModel[];
  finalCashFlowDetailData: CashFlowDetailModel[];
  // saveTheseIndexesForCFReport: Array<{index: number}>;

  assetLiabilitySections: any;
  public vm: any = {
    toDateSelect: [],
    fromDateSelect: [],
    DataFormat: 'MM/DD/YYYY',
    dateError: false,
    report: [],
    request: {
      toDate: null,
      fromDate: null,
      location_group_id: false,
      columns: '',
      company_id: null,
      location_id: null,
      rf_id_1: null,
      rf_id_2: null,
      rf_id_3: null,
      rf_id_4: null,
      rf_id_5: null,
      account_type_id: null,
      account_parent_id: null,
      account_subtotal_id: null,
    },
    showSpecificDates: false,
    buttonsDisabled: false,
    d: {
      date: '',
      name: '',
    },
    columns: false,
    company: [],
    locationGroup: [],
    location: [],
    currency: [],
    rfType: [],
    rf1: [],
    rf2: [],
    rf3: [],
    rf4: [],
    rf5: [],
    filtered: false,
    math: Math,
    showFilters: false,
    toDateError: false,
    totalDebits: 0,
    totalCredits: 0,
    liabEquityCurrent: 0,
    liabEquityPrior: 0,
    totalCurrentAssets: 0,
    totalPriorAssets: 0,
    companyData: null,
    locationData: null,
    calculatedTime: new Date(),
    priorToDate: 0,
    priorFromDate: 0,
    ToEmailError: null,
    showEmail: true,
    emailed: null,

    currentAR: null,
    priorAR: null,
    totalCurrentAR: null,
    totalPriorAR: null,
    deltaAR: null,

    currentAP: null,
    priorAP: null,
    totalCurrentAP: null,
    totalPriorAP: null,
    deltaAP: null,

    netCashFromOps: null,

    email: {
      toemail: null,
      fromemail: this.appConfigService.SysEmailAddress,
      PdfHtml: null,
      Subject: null,
    },
    monthCount: null,
    netIncomeCurrent: null,
    netIncomePrior: null,
    pdfFileName: null,
    totalCurrentRevenue: null,
    totalPriorRevenue: null,
    marginCurrent: null,
    marginPrior: null,
    fromDateError: null,
    accountTypeName: null,
    accountParentName: null,
    accountSubtotalName: null,
    accountSubtotal: null,
    accountParents: null,
    accountType: null,
    companyName: null,
    locationName: null,
    locationGroupName: null,
    rf1Name: null,
    rf2Name: null,
    rf3Name: null,
    rf4Name: null,
    rf5Name: null,
    accountInput: null,
    entityInput: null,
    Preferences: null,
    permissions: null,
    inventoryItem: [],
    entityState: [],
    entityCity: [],
    entityType: [],
    user: [],
    paymentType: [],
    bank: [],
    entityFilter: [],
    entity: [],
    inventoryItemFilter: [],
    exportToExcel: true,

    costCurent: null,
    costPrior: null,

    // Cash flow section totals and summary
    totalOperating: 0,
    totalInvesting: 0,
    totalFinancing: 0,
    netChangeInCash: 0,
    netCashFromOpsFormatted: '',
  };

  constructor(
    public localStorage: StorageService,
    public tableDataService: DataService,
    private titleService: Title,
    public appConfigService: AppConfigService,
    public dateFilter: DateFilterService,
    public notification: NotificationService,
    public route: ActivatedRoute,
    public excelExporter: DataExportService,
    public aEmail: EmailService,
    private emailData: EmailPassDataServiceService,
    private router: Router,
    public decimalPipe: DecimalPipe,
    private reportPrint: ReportPrintService,
    private destroyRef: DestroyRef,
  ) {
    this.vm.Preferences = JSON.parse(this.localStorage.StorageGet('Preferences'));
    this.vm.permissions = JSON.parse(this.localStorage.StorageGet('Permissions'));

    this.vm.email.toemail = this.localStorage.StorageGet('ToEmail', '');
  }

  ngOnInit() {
    this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
      if (params.toDate !== undefined) {
        this.vm.request.toDate = params.toDate;
        this.vm.showSpecificDates = true;
      }

      if (!this.vm.request.toDate) {
        this.newDateFilter(new Date(), new Date());
        this.primeDefaultDateRange();
      }

      // Always compute fromDate from toDate in As-of mode
      if (this.vm.request.toDate) {
        const tempTo = new Date(this.vm.request.toDate);
        const tempFrom = new Date(tempTo);
        tempFrom.setFullYear(tempTo.getFullYear() - 1);
        tempFrom.setMonth(tempTo.getMonth());
        tempFrom.setDate(1);
        this.vm.request.fromDate = tempFrom;
      }

      this.vm.request.columns = 'actual';
    });

    this.newDateFilter(this.vm.request.toDate, this.vm.request.fromDate);
    this.FilterOptionsInit();
    // this.EmailInit();
    this.rptName = $localize`:Cash Flow Statement @@cashFlowStatement:Cash Flow Statement`;
  }

  private primeDefaultDateRange() {
    const range = this.dateFilter.GetDefaultDateRange('currentMonth', this.vm.fromDateSelect, this.vm.toDateSelect);
    this.vm.request.toDate = range.toDate;
  }

  ngAfterViewInit() {
    this.titleService.setTitle(this.rptName);
  }

  ngAfterViewChecked() {
    // Legacy email pass-through removed in favor of SendEmailModalComponent
  }

  setEmailData() {
    const emailDocObj = {} as EmailModel;
    const reportName = 'Cash Flow Report';

    // printing options
    emailDocObj.print_orientation = '1';
    emailDocObj.convert_attachment_to = 'pdf';

    emailDocObj.fromEmail = '';
    emailDocObj.fromName = 'AcctXErp';
    emailDocObj.header_id = '';
    emailDocObj.toEmail = '';
    emailDocObj.body = 'Please see the attached ' + reportName + '.<br><br><br>'
      + 'Best regards,'
      + '<br><br>'
      + 'AcctXErp'
      + '<br><br>';
    emailDocObj.Subject = 'AcctXErp ' + reportName;

    // Use the same HTML as printing to ensure consistency
    try {
      emailDocObj.pdfHtml = this.buildPrintHtml(true);
    } catch {
      // Fallback to raw export container if builder fails
      try {
        const html = (this.ExcelExport?.nativeElement?.outerHTML || document.getElementById('excel-export')?.outerHTML || '');
        emailDocObj.pdfHtml = html;
      } catch {
        emailDocObj.pdfHtml = '';
      }
    }
    emailDocObj.activity_message = reportName;

    // deterministic file name
    const now = new Date();
    const yyyy = String(now.getFullYear());
    const mm = String(now.getMonth() + 1).padStart(2, '0');
    const dd = String(now.getDate()).padStart(2, '0');
    emailDocObj.FileName = 'Cash_Flow_Report_' + yyyy + mm + dd + '.pdf';

    this.reportDataToSendInEmail = emailDocObj;

    const openModal = () => {
      const element = document.getElementById('sendEmailModal') as HTMLElement;
      if (element) {
        const emailModal = new Modal(element);
        emailModal.show();
      }
    };

    setTimeout(openModal, 0);
  }

  exportToExcel() {
    this.excelExporter.exportToExcel(this.ExcelExport, this.rptName + '.xlsx');
  }

  emailReport(toEmail) {
    // if (this.vm.report.length > 0) {
    //   this.setEmailData();
    //   console.log('here');
    // }
    // const tempPdfHtml = this.ExcelExport.nativeElement.innerHTML;
    // this.vm.email.toemail = toEmail;
    // this.vm.email.PdfHtml = tempPdfHtml;
    // this.vm.email.Subject = this.rptName + ' ' + this.vm.request.toDate;
    // this.aEmail.sendEmail(this.vm.email);
  }

  newDateFilter(toDate, fromDate) {
    const ret = this.dateFilter.DateFilterInit(toDate, fromDate);
    this.vm.fromDateSelect = ret.fromDateSelect;
    this.vm.toDateSelect = ret.toDateSelect;
    this.vm.monthCount = ret.monthCount;
  }

  FilterOptionsInit() {
    this.tableDataService
      .getData('company?state=active&pageNumber=0&pageSize=999999')
      .subscribe((result: ResponseModel) => {
        this.vm.company = result.Data;
      });
    this.tableDataService
      .getData('currency?state=active&pageNumber=0&pageSize=999999')
      .subscribe((result: ResponseModel) => {
        this.vm.currency = result.Data;
      });
    this.tableDataService
      .getData('location?state=active&pageNumber=0&pageSize=999999')
      .subscribe((result: ResponseModel) => {
        this.vm.location = result.Data;
        // console.log('locs: ' +  this.vm.location);
      });
    this.tableDataService
      .getData('location_group?state=active&pageNumber=0&pageSize=999999')
      .subscribe((result: ResponseModel) => {
        this.vm.locationGroup = result.Data;
      });
    this.tableDataService
      .getData('reporting_field_type?state=active&pageNumber=0&pageSize=999999')
      .subscribe((result: ResponseModel) => {
        this.vm.rfType = result.Data;
      });
    this.tableDataService
      .getData('reporting_field', '?state=active&type_id=rf1&pageNumber=0&pageSize=999999')
      .subscribe((result: ResponseModel) => {
        this.vm.rf1 = result.Data;
      });
    this.tableDataService
      .getData('reporting_field', '?state=active&type_id=rf2&pageNumber=0&pageSize=999999')
      .subscribe((result: ResponseModel) => {
        this.vm.rf2 = result.Data;
      });
    this.tableDataService
      .getData('reporting_field', '?state=active&type_id=rf3&pageNumber=0&pageSize=999999')
      .subscribe((result: ResponseModel) => {
        this.vm.rf3 = result.Data;
      });
    this.tableDataService
      .getData('reporting_field', '?state=active&type_id=rf4&pageNumber=0&pageSize=999999')
      .subscribe((result: ResponseModel) => {
        this.vm.rf4 = result.Data;
      });
    this.tableDataService
      .getData('reporting_field', '?state=active&type_id=rf5&pageNumber=0&pageSize=999999')
      .subscribe((result: ResponseModel) => {
        this.vm.rf5 = result.Data;
      });
  }

  EmailInit() {
    // this.vm.email.toemail = this.localStorage.StorageGet('ToEmail');
  }

  filterEmptyCFData(data, filterValue: string) {
    const myStuff = data.filter((a) => a.parents.length > 0);
    // console.log('values :' + JSON.stringify(myStuff));
    this.getCFData(myStuff);
  }

  getCFData(data: CashFlowDetailModel) {
    // const saveTheseIndexesForCFReport = [{index: number}];
    // let saveTheseIndexesForCFReport: Array<{index: number}> = [];
    let saveTheseIndexesForCFReport = [];
    // console.log('cf detail model:' + JSON.stringify(data));
    for (const [x, value] of Object.entries(data)) {
      // console.log('cf detail values:' + JSON.stringify(value));
      for (const [p, valuesParents] of Object.entries(data[x].parents)) {
        // console.log('cf detail parent[] values:' + JSON.stringify(valuesParents));
        for (const [s, valuesSubs] of Object.entries(data[x].parents[p].subtotals)) {
          // console.log('cf detail sub[] values:' + JSON.stringify(valuesSubs));
          const sub = data[x].parents[p].subtotals[s].title;
          // console.log('cf detail account[] values:' + JSON.stringify(valuesSubs));
          for (const [a, valuesAccts] of Object.entries(data[x].parents[p].subtotals[s].accounts)) {
            // console.log('cf detail acct[] values:' + JSON.stringify(valuesAccts));
            for (const [aa, values] of Object.entries(data[x].parents[p].subtotals[s].accounts[a])) {
              // FINALLY, get values we want to use to calc CF stuff
              const subTotalCFValue = data[x].parents[p].subtotals[s].accounts[a].subTotCF;
              const priorValue = data[x].parents[p].subtotals[s].accounts[a].prior_period;
              const currentValue = data[x].parents[p].subtotals[s].accounts[a].current_period;
              const accountValue = data[x].parents[p].subtotals[s].accounts[a].account;

              if (subTotalCFValue !== null) {
                // console.log(
                //   'FINALLY *** cf account properties values:' +
                //     sub +
                //     ' -- ' +
                //     subTotalCFValue +
                //     ' -- Prior: ' +
                //     priorValue +
                //     ' -- Current: ' +
                //     currentValue +
                //     ' -- ' +
                //     accountValue +
                //     ' -- data index: ' +
                //     x
                // );
                saveTheseIndexesForCFReport.push(Number(x));
              }
            }
          }
        }
      }
    }
    // knock out the dups since we just let each occurence of them in above.
    const distinctThings = saveTheseIndexesForCFReport.filter(
      (thing, i, arr) => arr.findIndex((t) => t === thing) === i
    );

    // replace the array with the distinct array
    saveTheseIndexesForCFReport = distinctThings;

    // console.log('***FINAL array elements to use for report: ' + JSON.stringify(saveTheseIndexesForCFReport));

    // now filter main array based on those items we want to keep and ditch all the others
    // const res = this.vm.report.filter((el, i) => distinctThings.some((j) => i === j));
    const res = this.vm.report.filter((obj, index) => distinctThings.includes(index));
    // console.log('++++++++', res);
  }

  getWithObjKey(data) {
    for (const { key, value } of data) {
    }
  }

  calcTotals() {
    // sets and gets the CF section prior and current data we need for report.
    this.filterEmptyCFData(this.vm.report, 'cash-flow-financing');

    // Helper: safely get current/prior totals for a top-level group
    const getGroupTotals = (rec: any): { cur: number; prior: number } => {
      const curTop = Number(rec?.totalCurrentPeriod ?? rec?.totalCurrent ?? 0);
      const priorTop = Number(rec?.totalPriorPeriod ?? rec?.totalPrior ?? 0);
      // If top-level totals are non-zero, use them; otherwise aggregate from children
      if ((curTop || priorTop) || (rec?.parents == null)) {
        return {cur: isFinite(curTop) ? curTop : 0, prior: isFinite(priorTop) ? priorTop : 0};
      }
      let cur = 0;
      let prior = 0;
      try {
        const parents: any[] = Array.isArray(rec.parents) ? rec.parents : [];
        for (const p of parents) {
          const subs: any[] = Array.isArray(p?.subtotals) ? p.subtotals : [];
          for (const s of subs) {
            const accts: any[] = Array.isArray(s?.accounts) ? s.accounts : [];
            for (const a of accts) {
              cur += Number(a?.current_period ?? 0) || 0;
              prior += Number(a?.prior_period ?? 0) || 0;
            }
          }
        }
      } catch {
      }
      return {cur, prior};
    };

    // Reset totals
    this.vm.totalDebits = this.vm.totalCredits = this.vm.netIncomeCurrent = this.vm.netIncomePrior = 0;
    this.vm.totalCurrentAR = this.vm.totalPriorAR = 0;
    this.vm.totalCurrentAP = this.vm.totalPriorAP = 0;

    // Walk top-level groups to compute Net Income and collect Assets/Liabilities rollups
    const list: any[] = Array.isArray(this.vm.report) ? this.vm.report : [];
    for (const rec of list) {
      if (!rec) {
        continue;
      }
      const typeId = Number(rec.type_id);
      const {cur, prior} = getGroupTotals(rec);

      // Revenue and expense buckets to compute Net Income
      if (typeId === 4) { // Revenue
        this.vm.totalCurrentRevenue = cur;
        this.vm.netIncomeCurrent += cur;
        this.vm.totalPriorRevenue = prior;
        this.vm.netIncomePrior += prior;
      } else if (typeId === 6) { // COGS
        this.vm.marginCurrent = (this.vm.totalCurrentRevenue || 0) - cur;
        this.vm.marginPrior = (this.vm.totalPriorRevenue || 0) - prior;
        this.vm.COGSCurrent = cur;
        this.vm.COGSPrior = prior;
      } else if (typeId === 5) { // Operating expenses
        this.vm.costCurrent = cur;
        this.vm.costCurrentTotal = (this.vm.costCurrentTotal || 0) + cur;
        this.vm.costPrior = prior;
        this.vm.costPriorTotal = (this.vm.costPriorTotal || 0) + prior;
      }

      // Accumulate AR/AP rollups if available (legacy display)
      if (typeId === 1) { // Assets
        this.vm.totalCurrentAR = (this.vm.totalCurrentAR || 0) + cur;
        this.vm.totalPriorAR = (this.vm.totalPriorAR || 0) + prior;
      } else if (typeId === 2) { // Liabilities
        this.vm.totalCurrentAP = (this.vm.totalCurrentAP || 0) + cur;
        this.vm.totalPriorAP = (this.vm.totalPriorAP || 0) + prior;
      }
    }

    // Compute AR/AP deltas for legacy display
    this.vm.deltaAR = (this.vm.totalCurrentAR || 0) - (this.vm.totalPriorAR || 0);
    this.vm.deltaAP = (this.vm.totalCurrentAP || 0) - (this.vm.totalPriorAP || 0);
    // console.log('AR delta: ' + this.vm.deltaAR);
    // console.log('AP delta: ' + this.vm.deltaAP);

    // Compute Net Income
    this.vm.netIncomeCurrent = (this.vm.netIncomeCurrent || 0) - (this.vm.COGSCurrent || 0) - (this.vm.costCurrent || 0);
    this.vm.netIncomePrior = (this.vm.netIncomePrior || 0) - (this.vm.COGSPrior || 0) - (this.vm.costPrior || 0);

    // GAAP indirect CFO: Start with Net Income, adjust for changes in working capital
    // Working Capital delta = -(Δ Current Assets excluding cash) + (Δ Current Liabilities)
    // Refine to only use CURRENT sections (avoid non-current and cash equivalents)
    const isCurrentTitle = (t: any) => {
      const s = String(t || '').toLowerCase();
      return s.includes('current');
    };
    const isCashLike = (accountName: any) => {
      const s = String(accountName || '').toLowerCase();
      return s.includes('cash') || s.includes('bank');
    };

    const sumDeltaFor = (rec: any, wantAssets: boolean): number => {
      let sum = 0;
      try {
        const parents: any[] = Array.isArray(rec?.parents) ? rec.parents : [];
        for (const p of parents) {
          const subs: any[] = Array.isArray(p?.subtotals) ? p.subtotals : [];
          for (const s of subs) {
            if (!isCurrentTitle(s?.title) && !isCurrentTitle(p?.title)) {
              continue;
            }
            const accts: any[] = Array.isArray(s?.accounts) ? s.accounts : [];
            for (const a of accts) {
              if (isCashLike(a?.account)) {
                continue;
              } // exclude cash/cash equivalents
              const curV = Number(a?.current_period ?? 0) || 0;
              const priorV = Number(a?.prior_period ?? 0) || 0;
              sum += (curV - priorV);
            }
          }
        }
      } catch {
      }
      return sum;
    };

    let wcDelta = 0;
    for (const rec of list) {
      if (!rec) {
        continue;
      }
      const typeId = Number(rec.type_id);
      if (typeId === 1) { // Assets (use only current assets, excluding cash-like)
        wcDelta += -sumDeltaFor(rec, true);
      } else if (typeId === 2) { // Liabilities (use only current liabilities)
        wcDelta += +sumDeltaFor(rec, false);
      }
    }

    const gaapOpsNet = Number(this.vm.netIncomeCurrent || 0) + wcDelta;
    // Expose GAAP CFO explicitly for debugging/verification
    (this.vm as any).totalOperatingGaap = gaapOpsNet;

    // Use GAAP by default; fallback to section sum later in fillCFModel if zero/NaN
    this.vm.totalOperating = gaapOpsNet;
    this.vm.netCashFromOps = this.decimalPipe.transform(this.vm.totalOperating, '1.2-2');
    this.vm.netCashFromOpsFormatted = this.vm.netCashFromOps || '0.00';

    // console.log('net ops cash (GAAP indirect): ' + this.vm.netCashFromOps + ' | wcDelta: ' + wcDelta);
  }

  FilterObject(value, filterObj, except = false) {
    return new FilterPipe().transform(value, filterObj);
  }

  clearTotalizers() {
    this.vm.costCurent = null;
    this.vm.costPrior = null;

    this.vm.currentAR = null;
    this.vm.priorAR = null;
    this.vm.totalCurrentAR = null;
    this.vm.totalPriorAR = null;
    this.vm.deltaAR = null;

    this.vm.currentAP = null;
    this.vm.priorAP = null;
    this.vm.totalCurrentAP = null;
    this.vm.totalPriorAP = null;
    this.vm.deltaAP = null;
  }

  update() {
    this.lapCount++;
    this.clearTotalizers();
    this.vm.report = [];
    let errorDescription = '';
    this.vm.toDateError = false;
    this.vm.fromDateError = false;
    if (!this.vm.request.toDate) {
      errorDescription += $localize`:A To date is required. @@aTodateisrequired:A To date is required.` + ' ';
      this.vm.toDateError = true;
    }

    const tempToDate: any = new Date(this.vm.request.toDate);
    // Compute fromDate automatically: first day of the same month one year prior
    const tempFromDate: any = (() => {
      const t = new Date(tempToDate);
      t.setFullYear(tempToDate.getFullYear() - 1);
      t.setMonth(tempToDate.getMonth());
      t.setDate(1);
      return t;
    })();
    // No user-provided fromDate required in As-of mode; validate order anyway
    if (tempFromDate > tempToDate) {
      errorDescription += $localize`:The From Date must be less than or equal to the To Date. @@fromDateLesseqToDate:The From Date must be less than or equal to the To Date.` + ' ';
      this.vm.dateError = true;
    }
    if (errorDescription) {
      this.notification.warning(errorDescription);
    } else {
      // Format dates for API
      this.vm.request.toDate = this.dateFilter.GetDateFormat(this.vm.request.toDate);
      this.vm.request.fromDate = this.dateFilter.GetDateFormat(tempFromDate);

      // Calculate monthCount based on computed span
      this.vm.monthCount = (tempToDate - tempFromDate) / 86400 / 30 / 1000;
      this.vm.buttonsDisabled = true;
      this.vm.netIncomeCurrent = this.vm.netIncomePrior = 0;

      let paramString = '';
      if (this.vm.request.fromDate) {
        paramString += '&fromDate=' + this.vm.request.fromDate;
      }
      if (this.vm.request.toDate) {
        paramString += '&toDate=' + this.vm.request.toDate;
      }
      if (this.vm.request.company_id) {
        paramString += '&company_id=' + this.vm.request.company_id;
      }
      if (this.vm.request.location_id) {
        paramString += '&location_id=' + this.vm.request.location_id;
      }
      if (this.vm.request.location_group_id) {
        paramString += '&location_group_id=' + this.vm.request.location_group_id;
      }
      if (this.vm.request.rf_id_1) {
        paramString += '&rf_id_1=' + this.vm.request.rf_id_1;
      }
      if (this.vm.request.rf_id_2) {
        paramString += '&rf_id_2=' + this.vm.request.rf_id_2;
      }
      if (this.vm.request.rf_id_3) {
        paramString += '&rf_id_3=' + this.vm.request.rf_id_3;
      }
      if (this.vm.request.rf_id_4) {
        paramString += '&rf_id_4=' + this.vm.request.rf_id_4;
      }
      if (this.vm.request.rf_id_5) {
        paramString += '&rf_id_5=' + this.vm.request.rf_id_5;
      }

      if (paramString[0] === '&') {
        paramString = paramString.substring(1);
      }
      this.tableDataService.getData('cashflow', '?' + paramString).subscribe((result: any[]) => {
        this.vm.report = result;
        // console.log(JSON.stringify(this.vm.report));
        this.vm.filtered = false;
        this.vm.showFilters = this.vm.buttonsDisabled = false;
        this.calcTotals();
        this.fillCFModel();
        this.lapCount = 0;
      });
      // return false;
    }
  }

  fillCFModel() {
    this.cashFlowData = [];
    this.tempCashFlowData = [];
    this.finalCashFlowData = [];

    this.vm.report.forEach((x) => {
      // console.log('parent length: ' + x.parents.length);
      if (x.parents.length > 0) {
        x.parents.forEach((parents) => {
          // console.log('parents :' + JSON.stringify(parents));
          parents.subtotals.forEach((subs) => {
            // console.log('subs :' + JSON.stringify(subs));
            subs.accounts.forEach((accts) => {
              // console.log('accts: ' + JSON.stringify(accts));
              if (accts.acctCF != null) {
                this.tempCashFlowData.push(accts);
              }
            });
          });
        });
      }
    });

    // console.log('cf model data before reduce: ' + JSON.stringify(this.tempCashFlowData));

    // use reduce to sectionalize it out of the larger json file from api
    this.cashFlowData = this.groupByCFSection(this.tempCashFlowData);

    // now add the cf_section key, so we can group in html
    const resultArray = Object.keys(this.cashFlowData).map((index) => {
      const section = { cf_section: 'change_me', accounts: this.cashFlowData[index] };
      return section;
    });

    // finally, set the correct value of the cf_section key
    resultArray.forEach((obj) => {
      if (obj.cf_section === 'change_me') {
        obj.cf_section = obj.accounts[0].acctCF; // all obj elements props have same value so just reading first
      }
    });
    // console.log('resultarray : ' + JSON.stringify(resultArray));
    this.finalCashFlowData = resultArray;

    // now lets build JSON to populates the assets / liabs sections - just pulling it out of main data
    this.assetLiabilitySections = this.vm.report.filter((a) => a.type_id < 3);
    // console.log('assetLiabSection : ' + JSON.stringify(this.assetLiabilitySections));

    // Compute section totals for Operating (fallback), Investing and Financing (sum of current_period)
    try {
      const sumSection = (predicate: (s: any) => boolean): number => {
        const section = (this.finalCashFlowData || []).find(predicate);
        if (!section || !Array.isArray(section.accounts)) {
          return 0;
        }
        return section.accounts.reduce((acc: number, a: any) => acc + Number(a?.current_period || 0), 0);
      };
      const sumSectionPrior = (predicate: (s: any) => boolean): number => {
        const section = (this.finalCashFlowData || []).find(predicate);
        if (!section || !Array.isArray(section.accounts)) {
          return 0;
        }
        return section.accounts.reduce((acc: number, a: any) => acc + Number(a?.prior_period || 0), 0);
      };
      const isOperating = (s: any) => String(s?.cf_section || '').toLowerCase().includes('operat');
      const isInvesting = (s: any) => String(s?.cf_section || '').toLowerCase().includes('invest');
      const isFinancing = (s: any) => String(s?.cf_section || '').toLowerCase().includes('financ');

      // Section sums (current and prior) from detail rows
      const investingCurrent = sumSection(isInvesting);
      const financingCurrent = sumSection(isFinancing);
      const operatingSectionSumCurrent = sumSection(isOperating);
      const investingPrior = sumSectionPrior(isInvesting);
      const financingPrior = sumSectionPrior(isFinancing);
      const operatingSectionSumPrior = sumSectionPrior(isOperating);

      this.vm.totalInvesting = investingCurrent;
      this.vm.totalFinancing = financingCurrent;

      // If Operating is still zero from GAAP calc but section data exists, use section sum as a fallback
      const opFromGaap = Number(this.vm.totalOperating || 0);
      if ((opFromGaap === 0 || isNaN(opFromGaap)) && operatingSectionSumCurrent !== 0) {
        this.vm.totalOperating = operatingSectionSumCurrent;
        // Keep the formatted field in sync for the template/email
        try {
          this.vm.netCashFromOps = this.decimalPipe.transform(this.vm.totalOperating, '1.2-2');
          this.vm.netCashFromOpsFormatted = this.vm.netCashFromOps || '0.00';
        } catch {
        }
      }

      // Net change in cash = Operating + Investing + Financing (current)
      const op = Number(this.vm.totalOperating || 0);
      const inv = Number(this.vm.totalInvesting || 0);
      const fin = Number(this.vm.totalFinancing || 0);
      this.vm.netChangeInCash = op + inv + fin;

      // Expose section totals for % computations in the template
      this.vm.sectionTotals = {
        operatingCurrent: op,
        investingCurrent: investingCurrent,
        financingCurrent: financingCurrent,
        totalCurrent: op + investingCurrent + financingCurrent,
        operatingPrior: operatingSectionSumPrior,
        investingPrior: investingPrior,
        financingPrior: financingPrior,
        totalPrior: operatingSectionSumPrior + investingPrior + financingPrior,
      };
    } catch {
      this.vm.totalInvesting = this.vm.totalInvesting || 0;
      this.vm.totalFinancing = this.vm.totalFinancing || 0;
      this.vm.netChangeInCash = this.vm.netChangeInCash || 0;
      this.vm.sectionTotals = this.vm.sectionTotals || {
        operatingCurrent: 0,
        investingCurrent: 0,
        financingCurrent: 0,
        totalCurrent: 0,
        operatingPrior: 0,
        investingPrior: 0,
        financingPrior: 0,
        totalPrior: 0
      };
    }

    // console.log('finalCF : ' + JSON.stringify(this.finalCashFlowData));
    // console.log('done');
  }

  groupArrayOfObjects(list, key) {
    return list.reduce((rv, x) => {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  }

  groupByCFSection(array) {
    return array.reduce((r, a) => {
      r[a.acctCF] = r[a.acctCF] || [];
      r[a.acctCF].push(a);
      return r;
    }, Object.create(CashFlowModel));
  }

  parseInt(val) {
    return parseInt(val, 10);
  }

  close() {
    this.router.navigateByUrl('/home').then();
  }

  clear(clear = false) {
    let inventoryItemInput: any;
    this.vm.report = [];
    this.vm.buttonsDisabled = false;
    if (clear) {
      this.vm.showEmail = false;
      this.vm.accountInput = this.vm.entityInput = inventoryItemInput = '';
      this.vm.report = [];
      this.vm.request = {
        toDate: null,
        fromDate: null,
        location_group_id: false,
        columns: '',
        company_id: null,
        location_id: null,
        rf_id_1: null,
        rf_id_2: null,
        rf_id_3: null,
        rf_id_4: null,
        rf_id_5: null,
        account_type_id: null,
        account_parent_id: null,
        account_subtotal_id: null,
      };
    }
  }

  // Print the report content using a generated HTML document (do not use PrintService)
  printReport() {
    try {
      const html = this.buildPrintHtml();
      this.printHtmlInIframe(html);
    } catch (e) {
      console.error('Cash Flow print failed', e);
      this.notification?.error?.('Unable to print Cash Flow Report');
    }
  }

  // Build a self-contained HTML for printing/emailing the current report
  private buildPrintHtml(forEmail: boolean = false): string {
    const rawContent = (this.ExcelExport?.nativeElement?.outerHTML || document.getElementById('excel-export')?.outerHTML || '').toString();
    const content = this.reportPrint.cleanContentHtml(rawContent);
    const from = this.vm?.request?.fromDate || '';
    const to = this.vm?.request?.toDate || '';
    const meta: { label: string; value: string }[] = [];
    if (from || to) {
      meta.push({label: 'Period', value: `${from} to ${to}`});
    }
    return this.reportPrint.buildHtml({title: 'Cash Flow Statement', contentHtml: content, meta, orientation: 'landscape'});
  }


  private printHtmlInIframe(html: string): void {
    this.reportPrint.printInIframe(html);
  }

}
